@if (loading) {
  <div class="page-loading">
    <span>
      <span></span>
    </span>
  </div>
}
@if (!loading && status) {
  <div class="order-confirmation print">
    <div class="order" [ngClass]="status.orderStatus">
      <div class="order-header">
        @if (true) {
          <img [alt]="status.orderStatus" [src]="status.statusImg" />
        }
        <h1>{{ status.statusTitle }}</h1>
      </div>
      <div class="order-main">
        <h2>{{ status.orderTitle }}</h2>
        <h3 id="order-{{ orderId }}">Order Number: {{ orderId }}</h3>
        @if (order) {
          <section>
            <p>{{ order.item.title }}</p>
            @if (order.item.type == 'ballot' || order.item.type == 'ticket') {
              <p>
                {{ order.item.display_location
                }}<span> - {{ order.item.display_date }}</span>
              </p>
            }
            <p class="status-text">{{ status.statusText }}</p>
            <table aria-describedby="order-{{ orderId }}">
              <thead>
                <tr>
                  <th scope="col">Quantity</th>
                  <th scope="col">Price type</th>
                  <th scope="col" class="hide-mobile">Price</th>
                  <th scope="col">Total</th>
                </tr>
              </thead>
              <tbody>
                @for (item of order.items; track item) {
                  @for (option of item.options | keyvalue; track option) {
                    <tr>
                      <td>{{ option.value.qty }}</td>
                      <td>{{ option.value.label }}</td>
                      <td class="hide-mobile">
                        {{
                        option.value.price !== 0
                        ? (option.value.price / 100 | currency : '£')
                        : 'Free'
                        }}
                      </td>
                      <td>
                        {{
                        option.value.total != 0
                        ? (option.value.total / 100 | currency : '£')
                        : 'Free'
                        }}
                      </td>
                    </tr>
                  }
                }
                <tr>
                  <td></td>
                  <td></td>
                  <td class="hide-mobile">Total</td>
                  <td class="top-border">
                    <strong>
                      {{
                      order.total != 0
                      ? (order.total / 100 | currency : '£')
                      : 'Free'
                      }}
                    </strong>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="addresses">
              @if (order.billingAddress.postCode) {
                <div class="billing-address">
                  <h5>Billing Address</h5>
                  <ul>
                    <li>{{ order.billingAddress.address1 }}</li>
                    <li>{{ order.billingAddress.address2 }}</li>
                    <li>{{ order.billingAddress.city }}</li>
                    <li>{{ order.billingAddress.county }}</li>
                    <li>{{ order.billingAddress.state }}</li>
                    <li>{{ order.billingAddress.postCode }}</li>
                    <li>{{ order.billingAddress.country }}</li>
                  </ul>
                </div>
              }
              @if (order.item.delivery_method === 'post') {
                <div
                  class="delivery-address"
                  >
                  <h5>Delivery Address</h5>
                  <ul>
                    <li>{{ order.shippingAddress.address1 }}</li>
                    <li>{{ order.shippingAddress.address2 }}</li>
                    <li>{{ order.shippingAddress.city }}</li>
                    <li>{{ order.shippingAddress.county }}</li>
                    <li>{{ order.shippingAddress.state }}</li>
                    <li>{{ order.shippingAddress.postCode }}</li>
                    <li>{{ order.shippingAddress.country }}</li>
                  </ul>
                </div>
              }
            </div>
          </section>
        }
        @if (statusType == 'statusError') {
          <section>
            <p class="status-text">
              There has been a problem with your order<br />
              please <a [href]="mailTo">contact</a> Partner Choice for further
              details.
            </p>
          </section>
        }
      </div>
      @if (order?.item) {
        <div class="order-footer">
          <p>
            @if (orderStatus === 'success' || orderStatus === 'pending') {
              <span
                >Thank you for your payment.</span
                >
              }
              For {{ order.item.type }} information or terms and conditions please
              click
              <a [href]="order.item.terms_and_conditions">here</a>
            </p>
          </div>
        }
      </div>
    </div>
  }
